export const initialIntercomState = {
    getHash: {},
    getConversation: {},
};
export const IntercomActionTypes = {
    GET_CONVERSATION: '@@platform/intercom/GET_CONVERSATION',
    GET_HASH: '@@platform/intercom/GET_HASH',
};
